var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _class2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr, belongsTo } from '@ember-data/model';
import { fragmentArray, fragment, array } from 'ember-data-model-fragments/attributes';
import CatalogFragment from '@square/dashboard-items-data/models/connect/catalog-fragment';
let Data = (_dec = attr('string'), _dec2 = fragmentArray('connect/subscription-plan/phase'), _dec3 = fragment('connect/subscription-plan/subscription-configuration'), _dec4 = attr('boolean'), _dec5 = array(), _dec6 = array(), _dec7 = attr('boolean'), _dec8 = attr('number'), _dec9 = belongsTo('connect/checkout-link', {
  async: false
}), _class = (_class2 = class Data extends CatalogFragment {
  constructor(...args) {
    super(...args);
    /* variations are linked to the parent object. */
    _initializerDefineProperty(this, "name", _descriptor, this);
    _initializerDefineProperty(this, "phases", _descriptor2, this);
    _initializerDefineProperty(this, "configuration", _descriptor3, this);
    _initializerDefineProperty(this, "canProrate", _descriptor4, this);
    _initializerDefineProperty(this, "eligibleItemIds", _descriptor5, this);
    _initializerDefineProperty(this, "eligibleCategoryIds", _descriptor6, this);
    _initializerDefineProperty(this, "allItems", _descriptor7, this);
    _initializerDefineProperty(this, "monthlyBillingAnchorDate", _descriptor8, this);
    _initializerDefineProperty(this, "checkoutLink", _descriptor9, this);
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'connect/subscription-plan/data'), _class2), _descriptor = _applyDecoratedDescriptor(_class.prototype, "name", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "phases", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "configuration", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "canProrate", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "eligibleItemIds", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "eligibleCategoryIds", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "allItems", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "monthlyBillingAnchorDate", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "checkoutLink", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { Data as default };